var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSellTakeOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icon-park-solid:order"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2171_2294",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 2,
    width: 34,
    height: 42
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.6732 6.70825H36.417C36.9253 6.70825 37.4128 6.91019 37.7723 7.26963C38.1317 7.62908 38.3337 8.11659 38.3337 8.62492V40.2499C38.3337 40.7583 38.1317 41.2458 37.7723 41.6052C37.4128 41.9647 36.9253 42.1666 36.417 42.1666H9.58366C9.07533 42.1666 8.58782 41.9647 8.22837 41.6052C7.86893 41.2458 7.66699 40.7583 7.66699 40.2499V8.62492C7.66699 8.11659 7.86893 7.62908 8.22837 7.26963C8.58782 6.91019 9.07533 6.70825 9.58366 6.70825H16.292V9.58325H29.7087V6.70825H31.6732Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.292 3.83325H29.7087V9.58325H16.292V3.83325Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25.8757 18.2083L18.209 25.8759H27.7962L20.1257 33.5425",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2171_2294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0 0H46V46H0V0Z",
    fill: "#FF5411"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSellTakeOrder);
export default __webpack_public_path__ + "static/media/icon_sell_take_order.0143aebd6140aa6d3f56c0937d55169d.svg";
export { ForwardRef as ReactComponent };